import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms'; 
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './Pages/Login/login/login.component';
import { NgxSpinnerService } from 'ngx-spinner'; 
import { CustomAjax } from './AjaxHelper';
import { HomeComponent } from './Pages/home/home.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';  
import { NavigationBarComponent } from './Pages/Components/navigation-bar/navigation-bar.component';
import { SchedulerComponent } from './Pages/Components/scheduler/scheduler.component';
import { BryntumSchedulerModule } from '@bryntum/scheduler-angular';
import { ServiceMainPageComponent } from './Pages/service-main-page/service-main-page.component';
import { ForgotPasswordComponent } from './Pages/Login/forgot-password/forgot-password.component';
import { PasswordResetComponent } from './Pages/Login/password-reset/password-reset.component';
import { EmailPopupComponent } from './Pages/Components/email-popup/email-popup.component';
import { NotificationPopupComponent } from './Pages/Components/notification-popup/notification-popup.component';
import { ServicePopupComponent } from './Pages/Components/service-popup/service-popup.component';
import { PatientsMainPageComponent } from './Pages/patients-main-page/patients-main-page.component';
import { PatientSetupPopupComponent } from './Pages/Components/patient-setup-popup/patient-setup-popup.component';
import { AppointmentSetupPopupComponent } from './Pages/Components/appointment-setup-popup/appointment-setup-popup.component';
import { MeetingSetupPopupComponent } from './Pages/Components/meeting-setup-popup/meeting-setup-popup.component';
import { AppointmentSummaryComponent } from './Pages/appointment-summary/appointment-summary.component';
import { StaffMainPageComponent } from './Pages/staff-main-page/staff-main-page.component';
import { StaffSetupPopupComponent } from './Pages/Components/staff-setup-popup/staff-setup-popup.component';
import { AdministrationPopupComponent } from './Pages/Components/administration-popup/administration-popup.component';
import { CheckoutPopupComponent } from './Pages/Components/checkout-popup/checkout-popup.component';
import { ReportsMainPageComponent } from './Pages/reports-main-page/reports-main-page.component';
import { CustomDropdownComponent } from './Pages/Components/custom-dropdown/custom-dropdown.component';
import { PaginationComponent } from './Pages/Components/pagination/pagination.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { SurveyComponent } from './Pages/survey/survey.component';
import { CalendarDropdownComponent } from './Pages/Components/calendar-dropdown/calendar-dropdown.component';
import { DayViewSchedulerComponent } from './Pages/Components/scheduler/day-view-scheduler/day-view-scheduler.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    NavigationBarComponent,
    SchedulerComponent,
    ServiceMainPageComponent,
    ForgotPasswordComponent,
    PasswordResetComponent,
    EmailPopupComponent,
    NotificationPopupComponent,
    ServicePopupComponent,
    PatientsMainPageComponent,
    PatientSetupPopupComponent,
    AppointmentSetupPopupComponent,
    MeetingSetupPopupComponent,
    StaffMainPageComponent,
    StaffSetupPopupComponent,
    AppointmentSummaryComponent,
    AdministrationPopupComponent,
    CheckoutPopupComponent,
    ReportsMainPageComponent,
    CustomDropdownComponent,
    PaginationComponent,
    SurveyComponent,
    CalendarDropdownComponent,
    DayViewSchedulerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule, // Ensure FormsModule is here
    RouterModule.forRoot([]),
    BryntumSchedulerModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ContextMenuModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    CustomAjax,
    NgxSpinnerService // NgxSpinnerService should be here
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
